module.exports = __webpack_public_path__ + "img/studio.106226b5.jpg";